// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkable.input .el-checkbox__inner{vertical-align:middle}.checkable.input .el-checkbox__label{overflow-wrap:anywhere}", ""]);
// Exports
module.exports = exports;
